import { createFileRoute, getRouteApi, useNavigate } from "@tanstack/react-router";
import { Button } from "@heroui/react";
import { CircleX } from "lucide-react";
import { asSearchString } from "@repo/utils/search-params";

export type ResultFailSearch = {
  title?: string;
  message?: string;
  op?: string;
  redirect?: string;
};

export const Route = createFileRoute("/result/fail")({
  validateSearch: (search: Record<string, unknown>): ResultFailSearch => ({
    title: asSearchString(search.title),
    message: asSearchString(search.message),
    op: asSearchString(search.op),
    redirect: asSearchString(search.redirect),
  }),
  component: ResultFail,
});

const routeApi = getRouteApi("/result/fail");

export default function ResultFail() {
  const navigate = useNavigate();
  const search = routeApi.useSearch();
  const title = search.title ?? "操作失败";
  const op = search.op ?? "返回帮助中心";
  const redirect = search.redirect ?? "/help";

  return (
    <div className={"min-h-screen flex flex-col items-center justify-center px-6"}>
      <CircleX className="w-24 h-24 text-red-500" strokeWidth={1.5} />
      <div className={"mt-12 text-2xl font-bold text-center"}>{title}</div>
      {search.message && (
        <div className={"mt-3 text-sm text-gray-500 text-center"}>{search.message}</div>
      )}
      <div className={"mt-12 flex flex-col gap-6"}>
        <Button className={"h-12 w-64 rounded-full"} onPress={() => navigate({ href: redirect, replace: true })}>
          <div className={"text-lg"}>{op}</div>
        </Button>
      </div>
    </div>
  );
}
